import { render, staticRenderFns } from "./RoomSchedulePublicSwitch.vue?vue&type=template&id=abf52ab0&scoped=true&lang=pug"
import script from "./RoomSchedulePublicSwitch.vue?vue&type=script&lang=ts"
export * from "./RoomSchedulePublicSwitch.vue?vue&type=script&lang=ts"
import style0 from "./RoomSchedulePublicSwitch.vue?vue&type=style&index=0&id=abf52ab0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abf52ab0",
  null
  
)

export default component.exports